declare var solucx_temporal_front_end_id: string;
declare var solucx_temporal_key: string;
declare var solucx_temporal_url: string;

import Vue from 'vue';
import App from './App.vue';
import router from './routes';
import LogEvent from './services/LogEvent';
import SoluCXServiceOld from './services/SolucxServiceOld';
import URLParser from './services/URLParser';
import SoluCXServiceNew from './services/SolucxService';
import VueI18n from 'vue-i18n';
import i18n, { applyDocumentLanguage } from '@/services/Setupi18n';
import TemporalCountService from './services/TemporalCountService';

const conditions = ['/totem', '/tablet'];
const isTotemOrTablet = conditions.some((element) => location.href.includes(element));

// Global
Vue.prototype.$isTotemOrTablet = isTotemOrTablet;

Vue.use(VueI18n);

// Initialize services

// log
const logEvent = new LogEvent();

const params = new URLSearchParams(window.location.search); 
const apiURL = params.get('preview') != null ? process.env.VUE_APP_API_BASE_URL_PREVIEW : process.env.VUE_APP_API_BASE_URL;

// essas variáveis são do 'anti-robo' que fica fora do escopo vue no index.html
// precisa ficar lá para carregar antes de tudo e conseguir registrar a entrada na página o mais cedo possível
// depois são usadas no erviço TemporalCountService;
const url = typeof solucx_temporal_url == 'undefined' ? '' : solucx_temporal_url;
const id = typeof solucx_temporal_front_end_id == 'undefined' ? '0' : solucx_temporal_front_end_id;
const key = typeof solucx_temporal_key == 'undefined' ? '' : solucx_temporal_key;

applyDocumentLanguage();

// Get url parameters
new Vue({
  router,
  i18n,
  provide: () => ({
    temporalCountService: new TemporalCountService(url, id, key, 120, 3),
    logEvent,
    soluCXServiceOld: new SoluCXServiceOld(apiURL, router.currentRoute.params.apitoken),
    soluCXService: new SoluCXServiceNew({baseURL: apiURL, apiKey: router.currentRoute.params.apitoken, clientId: id}),
    urlParsedInfo: URLParser.parseNewTransactionFromParams(router.currentRoute),
  }),

  render: (h, x) => h(App),
  components: { App },
}).$mount('#app');
